import { ContactUsResponse } from "./../../../Models/ServerModels/ContactUs/ContactUsResponse";
import { ApiResponse } from "../../../Models";
import { ContactUsRequest } from "../../../Models/ServerModels/ContactUs/ContactUsRequest";
import { IHttpService } from "../IHttpService";
import { ApiServiceBase } from "./ApiServiceBase";
import Config from "../../../Configs";

export default class ContactUsApiService extends ApiServiceBase {
  constructor(client: IHttpService) {
    super(client);
  }

  async sendContactUs(data: ContactUsRequest): Promise<ApiResponse<ContactUsResponse>> {
    return await this._client.post<ContactUsResponse>(Config.apiPaths.contactUs, data);
  }
}
